import * as stacks from "./portfolio/stacks";

export const tutorials: ITutorial[] = [
  // CS50x
  {
    title: {
      english: "JavaScript for Beginners: Create a To Do List Step by Step",
      portuguese:
        "JavaScript para Iniciantes: Crie uma Lista de Tarefas Passo a Passo",
    },
    stack: [stacks.StackHTML, stacks.StackCSS, stacks.StackJavascript],
    link: "https://www.youtube.com/watch?v=1loPW0w2v7w",
    image: "http://img.youtube.com/vi/1loPW0w2v7w/maxresdefault.jpg",
    language: "portuguese",
  },
  {
    title: {
      english: "C Language - CS50x in Portuguese",
      portuguese: "Linguagem C - CS50X em Português",
    },
    stack: [stacks.StackC],
    link: "https://www.youtube.com/watch?v=Li85z0EfiUA",
    image: "http://img.youtube.com/vi/Li85z0EfiUA/maxresdefault.jpg",
    language: "portuguese",
  },
  {
    title: {
      english: "Scratch - CS50x in Portuguese",
      portuguese: "Scratch - CS50x em Português",
    },
    stack: [stacks.StackScratch],
    link: "https://www.youtube.com/watch?v=CfJYwHylIck",
    image: "http://img.youtube.com/vi/CfJYwHylIck/maxresdefault.jpg",
    language: "portuguese",
  },

  {
    title: {
      english: "JavaScript Drag and Drop App",
      portuguese: "Projetos com JavaScript: Arrastar e Soltar",
    },
    stack: [stacks.StackHTML, stacks.StackCSS, stacks.StackJavascript],
    link: "https://www.youtube.com/watch?v=7oCSdKeMDkc",
    image: "http://img.youtube.com/vi/7oCSdKeMDkc/maxresdefault.jpg",
    language: "portuguese",
  },
  {
    title: {
      english:
        "REST API + Authentication with NodeJS, MongoDB, TypeScript, and Express",
      portuguese:
        "Criando uma API REST + Processo de Autenticação com TypeScript, NodeJS, Express, e MongoDB",
    },
    stack: [
      stacks.StackNode,
      stacks.StackMongodb,
      stacks.StackTypescript,
      stacks.StackExpress,
    ],
    link: "https://www.youtube.com/watch?v=jdSm-3cFsMg",
    image: "http://img.youtube.com/vi/jdSm-3cFsMg/maxresdefault.jpg",
    language: "portuguese",
  },
  {
    title: {
      english: "JavaScript Random Password Generator",
      portuguese: "Projetos com JavaScript: Gerador de Senhas Aleatórias",
    },
    stack: [stacks.StackHTML, stacks.StackCSS, stacks.StackJavascript],
    link: "https://www.youtube.com/watch?v=BnvDc5ztbF8",
    image: "http://img.youtube.com/vi/BnvDc5ztbF8/maxresdefault.jpg",
    language: "portuguese",
  },
  /*
  {
    title: {
      english: "",
      portuguese: "",
    },
    stack: [],
    link: "",
    image: "http://img.youtube.com/vi/<VIDEO_ID>/maxresdefault.jpg",
    language: "portuguese",
  }
  */
];
